import { forwardRef, type InputHTMLAttributes } from 'react';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  value: string | number | undefined | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Si numeric/decimal, la prop type doit rester text (sinon iOS bloque la virgule) */
  numeric?: boolean;
  decimal?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { value, onChange, type = 'text', numeric = false, decimal = false, className = '', inputMode, ...rest },
  ref,
) {
  // Pour les nombres flottants on garde type=number (clavier iOS) avec inputMode=decimal
  // pour faire apparaître la virgule. Pour les entiers, inputMode=numeric.
  const computedInputMode = inputMode
    ?? (decimal ? 'decimal' : numeric ? 'numeric' : undefined);

  return (
    <input
      ref={ref}
      type={type}
      value={value ?? ''}
      onChange={onChange}
      inputMode={computedInputMode}
      className={[
        'w-full min-h-tap bg-zinc-950 border border-zinc-800 rounded-xl px-3 py-2.5',
        'text-zinc-100 placeholder-zinc-600',
        'focus:outline-none focus:border-accent-500 focus-visible:ring-2 focus-visible:ring-accent-400/30',
        'tabular-nums',
        className,
      ].filter(Boolean).join(' ')}
      {...rest}
    />
  );
});
